<template lang="pug">
  div.error
    top-nav(headerColor="white")
    .content
      .grid
        .col-3
          .title
            h1
              | Sorry, we couldn't find the page you were looking for!
            h2
              | <b> Error code: 404 </b> </br>
        .col-6
          visual(image="/static/images/404_image.jpg" alt="page not found 404")
          p.message
            | You can go back to the page that brought you here, or you can look for the page you want using our site search.
    bottom-nav(footerColor="white")
</template>

<script>
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'error',
  mixins: [ComponentMixin]
}
</script>

<style lang="sass">
  .error
    .content
      .title
        margin-top: 14rem
        h2
          font-size: 2rem
          letter-spacing: -0.1rem
          line-height: 150%
          padding-top: 2rem
        h1
          font-size: 5rem
          font-style: normal
          line-height: 95%
      .message
        margin-top: 6rem

</style>



// WEBPACK FOOTER //
// Error.vue?2cbb67f8